import React, { FC } from 'react';

import { Box } from '@mui/material';
import { DesktopAccountDetailRow } from './AccountDetail.styles';

export const DesktopAccountDetail: FC<{
  title: string;
  subtitle?: string;
  value: string;
}> = ({ title, subtitle, value }) => (
  <DesktopAccountDetailRow>
    <Box component="span">
      {title}:{subtitle && <Box component="span">{subtitle}</Box>}
    </Box>
    <Box component="span">{value}</Box>
  </DesktopAccountDetailRow>
);
